<script>
import { IndexList } from 'mint-ui'

export default {
	extends: IndexList,
	name: 'NoNavIndexList'
}
</script>

<style lang="scss">
.mint-indexlist {
	.mint-indexlist-content {
		margin-right: 0 !important;
	}

	.mint-indexsection {
		.mint-indexsection-index {
			margin: 0;
			padding: 10px 15px;
			background-color: #dedede;
			font-size: 0.8rem;
			font-weight: 500;
			letter-spacing: 3px;
		}
	}
}
.mint-indexlist > .mint-indexlist-nav {
	display: none !important;
}
</style>
